import { makeStyles } from '@material-ui/core/styles';
import PageviewIcon from '@material-ui/icons/Pageview';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
} from 'candy-commons-components';

import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    useTranslate,
} from 'react-admin';

import CustomToolbar from '../../../components/CustomToolbar';

const DiscoverCategoriesEdit = ({ permissions = {}, ...props }) => {
    const classes = useStyles();
    const { id } = props;
    const translation = useTranslate();
    const isEditDisabled = !permissions?.discover?.update;
    const breadcrumbsData = [
        {
            text: translation('resources.discover-categories.name'),
            url: 'discover-categories',
            icon: <PageviewIcon />,
        },
        {
            text: id,
            url: '',
        },
    ];

    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Edit className={classes.reverseButtonSave} {...props}>
                <SimpleForm
                    toolbar={
                        <CustomToolbar
                            permissions={permissions}
                            isEditDisabled={isEditDisabled}
                        />
                    }
                >
                    <ContainerFieldsList>
                        <TextInput
                            source="categoryName"
                            validate={required()}
                            disabled={true}
                        />
                        <TextInput
                            source="categoryKey"
                            validate={required()}
                            disabled={isEditDisabled}
                        />
                    </ContainerFieldsList>
                </SimpleForm>
            </Edit>
        </>
    );
};
const useStyles = makeStyles({
    reverseButtonSave: {
        '& .MuiToolbar-root>div': {
            flexDirection: 'row-reverse',
        },
    },
});
export default DiscoverCategoriesEdit;
